import { nullable } from 'io-ts/lib/Decoder';

import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

import { DecisionType } from './DecisionType';

export const AudienceDecisions = iotsUtils.makePartialRecordDecoder(
	constants.transaction.review.audienceTypes,
	nullable(DecisionType)
);
